module.exports = __webpack_public_path__ + "static/media/tti_reason_3@3x.33ff4e5f.png";